/* @flow */

type SegmentEvent =
  | 'Download Link Form Submitted'
  | 'Estimate Requested'
  | 'Lugger Applicant Created'
  | 'Order Completed'
  | 'New Partner Signup'
  | 'Product List Viewed';

export default {
  identify(id: string, properties?: Object) {
    window.analytics.identify(id, properties);
  },

  page() {
    window.analytics.page();
  },

  track(event: SegmentEvent, properties?: Object) {
    window.analytics.track(event, properties);
  },
};



// WEBPACK FOOTER //
// ./src/utilities/Segment.js